import PropTypes from "prop-types";
import React from "react";

import cx from "classnames";
import styles from "./styles.module.scss";

import { Image, Grid, Row, Col } from "react-bootstrap";
import DOMPurify from "dompurify";

import buildUrl from "build-url-ts";
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import { shouldFetchIntegrations } from "src/legacy/services/utils";
import { ZoomSideBar } from "./ZoomSideBar";
import { localizedStrings } from "src/localization/index.jsx";
import SwitchButton from "src/components/switchButton";

import _ from "lodash";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class ZoomView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteConfirmation: false,
      showIntergrationOnboarding: _.get(this.props, "integration") == 0,
      isScrollDisabled: false,
      selectedTab: null,
    };
    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.canEdit = this.canEdit.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedZoom = localizedStrings.components.integrations.zoom;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions =
      localizedStrings.components.integrations.actions;
    this.showIntergrationOnboarding =
      this.showIntergrationOnboarding.bind(this);
  }

  componentDidMount() {
    if (shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
  }

  _handleDeactivateClicked() {
    this.setState({
      deleteConfirmation: true,
    });
  }

  canEdit() {
    return this.props.user.admin;
  }

  showIntergrationOnboarding() {
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding,
    });
  }

  disableScroll(value) {
    this.setState({
      isScrollDisabled: value,
    });
  }

  handleChange = () => {
    const current = this.isSelected(); 
    this.props.updateZoomRecordingToggle({ enabled: !current });
  };

  handleScroll = (e) => {
    if (this.state.isScrollDisabled) {
      return;
    }
    const integration =
      localizedStrings.constants.integrationsOnboarding.integrations.zoom;
    const sections = integration.sections;
  
    const buffer = 25;
    let selectedTabIndex = 0;
    for (let i = 0; i < sections.length; i++) {
      const sectionId = sections[i].id;
      const element = document.getElementById(sectionId);

      if (element) {
        const { top } = element.getBoundingClientRect();
        const position = top;

        if (e.target.scrollTop >= position - buffer) {
          selectedTabIndex = i;
        }
      }
    }

    this.setState({
      selectedTab: sections[selectedTabIndex].id,
    });
  };

  render() {
    var isAuthenticated = false;

    if (
      this.props.integration &&
      this.props.integration.state.code === "ok" &&
      !this.props.error
    ) {
      isAuthenticated = true;
    }

    var isTokenExpired =
      _.get(this.props, "integration.state.code") === "auth_error";

    return (
      <div>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <ZoomSideBar
              integration={this.props.integration}
              handleAuthenticate={this.handleAuthenticate}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              deactivating={this.props.deactivating}
              isAuthenticated={isAuthenticated}
              authenticating={this.props.authenticating}
              isTokenExpired={isTokenExpired}
              navigate={this.props.navigate}
              handleIntegrationsBackButton={
                this.props.handleIntegrationsBackButton
              }
              isShowIntegrationOnboardingEnabled={
                this.state.showIntergrationOnboarding
              }
              canEdit={this.canEdit}
            />
          </Col>
          <Col
            md={9}
            id="right"
            className={styles.right}
          >
            
            {!this.props.integration && !isAuthenticated && (
              <div className={styles.authorize}>
                <h3>{this.localizedZoom.activate.title}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      this.localizedZoom.activate.sub_text
                    ),
                  }}
                /> 
              </div>
            )}

            {this.props.integration && !isAuthenticated && (
              <div className={styles.authorize}>
                <h2>{this.localizedZoom.expired.title}</h2>
                <p>{this.localizedZoom.expired.sub_text}</p>
              </div>
            )}
            
            {this.props.integration && isAuthenticated &&(
              <div className={styles.authFinish}>
                <h3 className={styles.secondLine}>
                  {" "}
                  {this.localizedZoom.active.title}{" "}
                  <h4>
                    {" "}
                    {this.localizedZoom.active.email}:{" "}
                    <i>{this.props.integration.configuration.email}</i>
                  </h4>
                </h3>
              </div>
            )}
            {this.canEdit() && (
            <div className={styles.callRecordingAccess}>
            <div className={styles.headerContainer}>
              <span className={styles.heading}>
                call-recording access
              </span>
              <span className={styles.subText}>
                Allow Paperflite to access your Zoom cloud recordings and transcripts.
              </span>
              </div>
              <SwitchButton
                className={styles.switch}
                checked={this.isSelected()} 
                handleCheck={() => this.handleChange()}
                />
            </div>
            )}
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name="Zoom"
          type="zoom"
          message={localizedStrings.formatString(
            this.localizedZoom.sliders.deactivate.sub_text,
            {
              email:
                (this.props.integration &&
                  this.props.integration.configuration.email) ||
                "",
            }
          )}
          show={this.state.deleteConfirmation}
          onCancel={() => {
            this.setState({
              deleteConfirmation: false,
            });
          }}
        />
      </div>
    );
  }

  handleAuthenticate() {
    //Calculate Position
    var dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : window.screen.left;

    var dualScreenTop =
      window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : window.screen.width;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/zoom/authorize`,
    });

    var newWindow = window.open(
      url,
      `Authorize Zoom Account`,
      "scrollbars=yes, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left,
    );

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, this.handleAuthenticateEvent, false);
    return false;
  }

  handleAuthenticateEvent(e) {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener
      ? "removeEventListener"
      : "detachEvent";
    var deEventer = window[detachEventMethod];
    var messageEvent =
      detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == "ZOOM_AUTHORIZATION_SUCCESS") {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;

      if (!error) {
        this.props.authenticateAccount(code, "zoom");
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }

  isSelected() {
    if (this.props.enabled !== null) {
      return this.props.enabled;
    }
  
    return this.props.integration?.configuration?.callRecordingEnabled ?? false;
  }
}

export default ZoomView;
